import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UpdateActiveLicenceDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateLicense = async ({
  id,
  license,
}: {
  id: string;
  license: UpdateActiveLicenceDto;
}): Promise<void> => {
  const { licenseId, ...licenseOverrides } = license;

  const response = await axiosClient.patch(
    `organisation-licenses/${id}/active-licence`,
    {
      licenseId,
      ...licenseOverrides,
    },
  );
  return response.data;
};

function useUpdateLicense(
  mutationOptions?: UseMutationOptions<
    void,
    HttpError,
    { id: string; license: UpdateActiveLicenceDto }
  >,
) {
  return useMutation({
    mutationFn: updateLicense,
    ...mutationOptions,
  });
}

export { useUpdateLicense };
